
export default function ResponseMessageDirective() {
    'ngInject';    
    return {
        template: require('./response-message.html'),
        restrict: 'E',
        transclude: true,
        scope: {
            /*
            "Reason" values to determine style of alert:
            'E' - 'error', should be used if we get an error back from an api call
            'M' - 'message', should be used in cases where result isn't an error but might be unexpected eg. if result of a search query is empty
            'S' - 'success', should be used for successful form submissions, property edits, etc.
            */
            reason: '='
        }
    };
}
